import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Star, BadgeCheck } from 'lucide-react';
export function ReviewsSection() {
  const reviews = [{
    name: 'Paola G.',
    role: 'Asesora Financiera',
    location: 'Miami, FL',
    plan: 'Plan 3 — Full Creation',
    text: 'Elegí el Plan 3 porque quería salir lista, no en proceso. En pocas semanas tenía mi empresa legal, mi EIN, mis documentos y mi landing page funcionando.',
    initial: 'P'
  }, {
    name: 'Sofía L.',
    role: 'Fotógrafa Profesional',
    location: 'California',
    plan: 'Asesoría Estratégica',
    text: 'Lo que diferencia a Inkova es Annysol. No es solo una gestora, es alguien que realmente entiende lo que estás construyendo. Te da claridad donde había confusión.',
    initial: 'S'
  }, {
    name: 'Andrés M.',
    role: 'Fotógrafo & Videógrafo',
    location: 'Florida',
    plan: 'Plan 1 — Fundación',
    text: 'Intenté hacer todo yo mismo con tutoriales de YouTube. Cometí un error en Sunbiz que me costó tiempo y dinero. Después llegué a Inkova y entendí la\u00a0diferencia.',
    initial: 'A'
  }, {
    name: 'Isabella R.',
    role: 'Nutricionista & Coach',
    location: 'Puerto Rico',
    plan: 'Plan 3 — Full Creation',
    text: 'El nivel de detalle, la comunicación y la calidad del trabajo final son difíciles de encontrar. No solo registran tu empresa: te dejan una base sólida para\u00a0crecer.',
    initial: 'I'
  }];
  // Duplicate for seamless loop
  const duplicated = [...reviews, ...reviews];
  const trackRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);
  return <section id="testimonios" className="py-20 bg-white overflow-hidden" data-id="element-372">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12" data-id="element-373">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-374">
          <h2 className="text-3xl md:text-4xl font-serif text-inkova-primary mb-2" data-id="element-375">
            Lo que dicen nuestros&nbsp;clientes
          </h2>
          <div className="w-20 h-1 bg-inkova-accent rounded-full mx-auto mt-4" data-id="element-376"></div>
        </motion.div>
      </div>

      <div className="relative" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} onTouchStart={() => setIsPaused(true)} onTouchEnd={() => setIsPaused(false)} data-id="element-377">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-378"></div>
        <div className="absolute right-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-379"></div>

        <div ref={trackRef} className="flex gap-5" style={{
        width: 'max-content',
        willChange: 'transform',
        animation: `scrollReviews 35s linear infinite`,
        animationPlayState: isPaused ? 'paused' : 'running'
      }} data-id="element-380">
          {duplicated.map((review, i) => <div key={i} className="flex-shrink-0 w-[280px] sm:w-[300px] bg-white p-6 rounded-2xl shadow-sm border border-[#C49FD8] flex flex-col" data-id="element-381">
              <div className="flex items-center mb-4" data-id="element-382">
                <div className="w-10 h-10 rounded-full bg-inkova-light text-inkova-primary flex items-center justify-center text-base font-bold mr-3 border border-inkova-accent/30" data-id="element-383">
                  {review.initial}
                </div>
                <div className="flex-1 min-w-0" data-id="element-384">
                  <h3 className="font-bold text-[#1A1A1A] text-sm flex items-center" data-id="element-385">
                    {review.name}
                    <BadgeCheck className="w-3.5 h-3.5 text-green-500 ml-1.5 flex-shrink-0" data-id="element-386" />
                  </h3>
                  <p className="text-xs text-gray-500 truncate" data-id="element-387">
                    {review.role} · {review.location}
                  </p>
                </div>
              </div>

              <div className="flex mb-3" data-id="element-388">
                {[...Array(5)].map((_, index) => <Star key={index} className="w-3.5 h-3.5 text-[#5A4579] fill-current" data-id="element-389" />)}
              </div>

              <p className="text-sm text-gray-700 leading-relaxed font-light italic flex-grow mb-4" data-id="element-390">
                "{review.text}"
              </p>

              <div className="pt-3 border-t border-gray-100" data-id="element-391">
                <span className="inline-block px-3 py-1 bg-inkova-light text-inkova-primary text-[10px] font-bold rounded-full border border-inkova-accent/30 uppercase tracking-wide" data-id="element-392">
                  {review.plan}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}